/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInner } from './LookupArtistsResponseArtistsInner';
import {
    LookupArtistsResponseArtistsInnerFromJSON,
    LookupArtistsResponseArtistsInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerToJSON,
} from './LookupArtistsResponseArtistsInner';

/**
 * 
 * @export
 * @interface LookupArtistsResponse
 */
export interface LookupArtistsResponse {
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInner>}
     * @memberof LookupArtistsResponse
     */
    artists: Array<LookupArtistsResponseArtistsInner>;
}

/**
 * Check if a given object implements the LookupArtistsResponse interface.
 */
export function instanceOfLookupArtistsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "artists" in value;

    return isInstance;
}

export function LookupArtistsResponseFromJSON(json: any): LookupArtistsResponse {
    return LookupArtistsResponseFromJSONTyped(json, false);
}

export function LookupArtistsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupArtistsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'artists': ((json['artists'] as Array<any>).map(LookupArtistsResponseArtistsInnerFromJSON)),
    };
}

export function LookupArtistsResponseToJSON(value?: LookupArtistsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'artists': ((value.artists as Array<any>).map(LookupArtistsResponseArtistsInnerToJSON)),
    };
}

